








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { QueryWorkOrdersRequest, Workorder } from 'performo-api';

@Component({})
export default class WorkOrderSetComponent extends Vue {
  @Prop({ required: true }) private order!: Workorder;
  @Prop({ required: false, default: false, type: Boolean }) hideLabel?: boolean;

  private popoverOpen = false;
  private paginationSkip = 0;

  get query() {
    const query: QueryWorkOrdersRequest = {
      setId: this.order.setId ? this.order.setId : '',
      skip: this.paginationSkip
    };

    return query;
  }

  openPopover() {
    this.popoverOpen = true;
  }

  orderClickedHandler(order: Workorder) {
    if (order.workorderId) {
      // Only re-route if the clicked order.workorderId is different than the currently viewed order
      // This is to prevent redundant navigation JS error - https://stackoverflow.com/a/66397865/10421823
      const path = '/orders/' + order.workorderId;
      if (this.$route.path !== path) {
        this.$router.push({
          name: 'work-order-detail',
          params: { id: order.workorderId }
        });
      }
      this.popoverOpen = false;
    }
  }

  viewSetInListHandler() {
    if (this.order.setId) {
      this.$router.push({
        name: 'work-orders',
        query: { setId: this.order.setId }
      });
    }
    this.popoverOpen = false;
  }

  closeSetList() {
    this.popoverOpen = false;
  }

  private paginationSkipUpdatedHandler(skip: number) {
    this.paginationSkip = skip;
  }

  private orderSetListCols = [
    {
      displayName: '',
      columnName: 'highlightedOrder',
      width: '25px',
      dontSort: true
    },
    {
      displayName: 'Order #',
      columnName: 'orderNumber',
      width: '90px',
      dontSort: true
    },
    {
      displayName: 'Job Type',
      columnName: 'jobType',
      dontSort: true
    },
    { displayName: 'Assign To', columnName: 'assignTo', dontSort: true },
    {
      displayName: 'Building',
      columnName: 'building',
      width: '175px',
      dontSort: true
    },
    { displayName: 'Status', columnName: 'orderStatus', dontSort: true }
  ];
}
